import { Col } from "antd";
import HighchartsReact from "highcharts-react-official";

// Safely add strategyId to each point
function enhanceSeriesWithStrategyId(series) {
  return (series || []).map((s) => ({
    ...s,
    data: Array.isArray(s?.data)
      ? s?.data?.map((point) => {
          return {
            ...point,
            strategyId: point?.summary_id ?? null,
          };
        })
      : [],
  }));
}

export default function VolSurfaceOptionsGraph({
  volSurfaceOptions,
  Highcharts,
}) {
  return (
    <Col className="vol-surface-graph" xxl={24}>
      {volSurfaceOptions?.graphs?.map((graphOptions, index) => {
        if (index !== 1) {
          const enhancedGraphOptions = {
            ...graphOptions,
            series: enhanceSeriesWithStrategyId(graphOptions.series),
            plotOptions: {
              series: {
                point: {
                  events: {
                    mouseOver: function () {
                      const strategyId = this.strategyId;
                      this.series.chart.series.forEach((series) => {
                        series.points.forEach((point) => {
                          if (point.strategyId === strategyId) {
                            point.setState("hover");
                          }
                        });
                      });
                    },
                    mouseOut: function () {
                      const strategyId = this.strategyId;
                      this.series.chart.series.forEach((series) => {
                        series.points.forEach((point) => {
                          if (point.strategyId === strategyId) {
                            point.setState("");
                          }
                        });
                      });
                    },
                  },
                },
              },
            },
            accessibility: { enabled: false },
          };

          return (
            <Col
              span={24}
              style={{ margin: "0px 5px 20px 5px" }}
              key={graphOptions.id || index}
            >
              <HighchartsReact
                highcharts={Highcharts}
                options={enhancedGraphOptions}
              />
            </Col>
          );
        } else {
          return null;
        }
      })}
    </Col>
  );
}
